/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { TaxRateDto } from '@gh/builder-shared-data';
import { ID } from '@gh/common-shared-data';

export type TaxRate = TaxRateDto;
export const getTaxRateId = (item: TaxRateDto) => item.taxType;

export const newTaxRate = (taxType: ID, name: string, taxRate: number = 0): TaxRateDto =>
  ({ taxType, taxRate, name });
